<template>
    <div>
        <div class="line__vertical-mains"></div>
        <!-- <promotion-alert/> -->
        <sub-header :micrositeUrl="micrositeUrl" />
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box">
                <!-- <Promotion class="promotion_mobile promo-margin"/> -->
                  <h1 class="caption__select">
                  <span>Seleccione una privada, clic para ver detalles</span>
                </h1>
                <map-highlight :lomalta="true" v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicators="indicators" />
                <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img" :id="id" :nivel="nivel" :desarrollo="desarrollo" :levelId="levelId" :url="url" />
                <div class="line_horizontal"></div>
                <Availables class="availables-mobile" :amountAvailables="amountAvailables" :nivel="nivel" />
            </div>
            <div class="select__box" :class="selectHide">
                <Select v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeFilter" />
                <Availables class="availables-desk" :amountAvailables="amountAvailables" :nivel="nivel" />
              <!--   <Promotion class="promotion_web"/> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../core/SubHeader.vue";
import MapHighlight from "../../core/MapHighlight";
import Select from "../../core/Select.vue";
import Availables from "../../core/Availables.vue";
import Button from "../../core/Button.vue";
/* import PromotionAlert from "../../core/PromotionAlert.vue";
import Promotion from "../../core/Promotion.vue"; */
export default {
    name: "Main",
    components: {
        SubHeader,
        MapHighlight,
       /*  PromotionAlert,
        Promotion, */
        Select,
        Availables,
        Button,
    },
    data() {
        return {
            id: 53,
            nivel: "towerStageLevel",
            levelId: 0,
            desarrollo: "lomalta",
            arrFilteredLocations: [],
            url: "lomalta",
            micrositeUrl: "https://www.tresmarias.com.mx/lomalta/terrenos",
            imgSet: [{
                name: 'lomalta',
                url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/MainLomAltaEne24.png',
                width: '900',
                height: '719',
                id: 53,
                levelId: 0,
                route: 'lomalta',
                nivel: 'towerStageLevel',
                transform: '',
                viewBox: '0 0 948 899.78'
            }],
            indicators: [
                { id: 150, text: 'PRIVADA 1', transform: 'matrix(1 0 0 1 237 43)', cxB: 352, cyB: 36.62, rB: 10.29, cxW: 352, cyW: 36.62, rW: 5.29, x1: 477.13, y1: 205.62, x2: 358.36, y2: 43.82, status: true },
                //
                { id: 151, text: 'PRIVADA 2', transform: 'matrix(1 0 0 1 50 93)', cxB: 166, cyB: 88.62, rB: 10.29, cxW: 166, cyW: 88.62, rW: 5.29, x1: 173.86, y1: 93.41, x2: 332.19, y2: 232.81, status: true },
                { id: 152, text: 'PRIVADA 3', transform: 'matrix(1 0 0 1 20 345)', cxB: 135.71, cyB: 336.62, rB: 10.29, cxW: 135.71, cyW: 336.62, rW: 5.29, x1: 142, y1: 336.62, x2: 258, y2: 336.62, status: true },
                //
                { id: 153, text: 'PRIVADA 8', transform: 'matrix(1 0 0 1 800 255)', cxB: 785.71, cyB: 249.62, rB: 10.29, cxW: 785.71, cyW: 249.62, rW: 5.29, x1: 658, y1: 249.62, x2: 778, y2: 249.62, status: true },
                //
                { id: 176, text: 'PRIVADA 4', transform: 'matrix(1 0 0 1 23 485)', cxB: 140.71, cyB: 475.62, rB: 10.29, cxW: 140.71, cyW: 475.62, rW: 5.29, x1: 148, y1: 475.62, x2: 228, y2: 475.62, status: true },
                { id: 177, text: 'PRIVADA 5', transform: 'matrix(1 0 0 1 30 655)', cxB: 147.71, cyB: 646.62, rB: 10.29, cxW: 147.71, cyW: 646.62, rW: 5.29, x1: 158, y1: 646.62, x2: 258, y2: 646.62, status: true },
                { id: 197, text: 'PRIVADA 6', transform: 'matrix(1 0 0 1 670 670)',/** */ cxB: 655.71, cyB: 659.62, rB: 10.29, cxW: 655.71, cyW: 659.62, rW: 5.29, x1: 548, y1: 549.62, x2: 648, y2: 652.62, status: true },
                { id: 198, text: 'PRIVADA 7', transform: 'matrix(1 0 0 1 830 445)', cxB: 815.71, cyB: 439.62, rB: 10.29, cxW: 815.71, cyW: 439.62, rW: 5.29, x1: 708, y1: 439.62, x2: 808, y2: 439.62, status: true },
                
            ],
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false
        };
    },

    computed: {
        ...mapGetters({
            locations: "getLocations",
        }),
        development() {
            return { id: this.id, level: 0 };
        },
        existFilter() {
            let arrExistFilter;
            if (this.rangeFilter) {
                arrExistFilter = this.arrFilteredLocations;
            } else if (this.rangeFilter === false) {
                arrExistFilter = this.locations;
            }
            return arrExistFilter;
        },
        returnAvailable() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.available > 0
            );
            return newArrfiltered;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.available >0
            );
            return newArrfiltered;
        },

        selectHide() {
            if (this.rangeFilter == false) {
                return 'u__dipslay--none'
            } else {
                return ''
            }
        }
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
    },
    async created() {
        await this.clearCoords();
        await this.getTowerStageLevels(this.development);
    },
    async beforeDestroy() {
        await this.clearCoords()
    }
};
</script>
